import React, { Component }  from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import {browserHistory} from "react-router";
import Favicon from 'react-favicon'

import fav from '../img/favicon.ico'
import Autolinker from 'autolinker'
import linkifyHtml from 'linkifyjs/html';
import {TOGGLE_LIST_HEADER_SUCCESS, TOGGLE_LISTS_SUCCESS} from "../actionTypes";





import {
    fetchLins,
    addLine,
    fetchTitle,
    editLine,
    removeLine,
    fetchTagsColor,
    addTagToLine,
    openComments,
    toggleDropBox,
    fetchComments,
    fetchTags,
    fetchNotificCommentIds,
    removeNotificCommentIds,
    //editFavicon,
    fetchUser,
    addImgToLine,
    fetchCommentsTime,
    addFilterTagIds,
    editUserLineUpdateTime,
    editUserCommentTime,
    saveRangy,
    fetchAuthUseList,
    addTag,
    fetchSettings,
    addSettings,
    editChecked,
    setDateOnLine,
    fetchKeyList

} from '../actions'
import { watchLines, watchTitle, watchComments, watchCommentsTime, watchLineUpdateTime, watchHistory} from '../actions/firebaseWatch'
import Line from '../components/Line'
import {getLines, getKeyLineByIndex, getTags, getKeyTagByIndex, getArrForLightBox} from '../selectors'
import {
    removeCommentNotificToLocalStograge,
    conditionCommentsTime,
    conditionLineUpdateTime,
    conditionHistoryTime,
    getLinkFromText
} from '../functions/snippets'
import favicons from "../data/favicons";
import Button from "../components/Button";
import ListHeader from '../components/ListHeader'
import History from '../containers/drop/History'


class Lists extends Component {
    constructor(props) {
        super(props)

        this.faviconNotific = this.faviconNotific.bind(this)

    }
    componentDidMount() {
        const { id } = this.props.ownProps.params
        this.props.fetchKeyList(id)

        this.props.watchLines(id, this.faviconNotific)
        this.props.watchTitle(id)
        this.props.watchComments(id)
        this.props.watchCommentsTime(id)
        this.props.watchLineUpdateTime(id)
        this.props.watchHistory(id)


        this.props.fetchLins(id)
        this.props.fetchTitle(id)
        this.props.fetchTagsColor(id)

        this.props.fetchSettings(id)
        //this.props.fetchNotificCommentIds()


        this.props.fetchCommentsTime(id)

        fetchAuthUseList(this.props.user.id);


        //faviconNotific()

        this.faviconNotific()
    }


    state = {
        notCount: 0,
        onlyActive: false
    }


    componentWillReceiveProps(nextProps) {
        const id = nextProps.ownProps.params.id;


        if (id !== this.props.ownProps.params.id) {
            this.props.fetchKeyList(id)

            this.props.fetchTitle(id)
            this.props.fetchTagsColor(id)
            this.props.fetchNotificCommentIds()
            this.props.fetchSettings(id)
            const  fetchNotData = async () => {
                await this.props.fetchTags(id)
                await this.props.fetchLins(id)
                //await this.props.fetchUser(id)
                await this.props.fetchCommentsTime(id)
            }
            fetchNotData().then(() => {
                this.faviconNotific()
            })

            this.props.watchLines(id, this.faviconNotific)
            this.props.watchTitle(id)
            this.props.watchComments(id)
            this.props.watchCommentsTime(id)
            this.props.watchLineUpdateTime(id)
            this.props.watchHistory(id)

        }

        if (nextProps.history !== this.props.history || nextProps.user !== this.props.user) {
            this.faviconHistory()
        }


        this.faviconNotific()
    }

    /*faviconNotific() {
        setTimeout(()=>{
            let alertCount = 0;
            this.props.lines.map((item, index) => {
                let cond = conditionCommentsTime(this.props.commentsTime, this.props.user.commentsTime, item.id)
                let cond2 = conditionLineUpdateTime(item.date, this.props.user.lineUpdateTime, item.id, this.props.user.id, item.userUpdate)


                cond && alertCount ++
                cond2 && alertCount ++
            })
            this.setState({
                notCount: alertCount
            })
        }, 100)
    }*/

    faviconNotific() {
        return
        setTimeout(()=>{
            let alertCount = 0;
            this.props.history.map((item, index) => {

                let cond = conditionHistoryTime(this.props.commentsTime, this.props.user.commentsTime, item.id)


                cond && alertCount ++
            })
            this.setState({
                notCount: alertCount
            })
        }, 100)
    }

    faviconHistory() {
        setTimeout(()=>{
            let alertCount = conditionHistoryTime(this.props.history, this.props.user);
            this.setState({
                notCount: alertCount
            })
        }, 100)
    }

    editUserAllUpdateTimeHandle = () => {
        const { lines, editUserLineUpdateTime, user} = this.props
        const { id } = this.props.ownProps.params


        const  fetchNotData = async () => {
            lines.forEach(async item => {
                await editUserLineUpdateTime(id, user.id, item.id);
                let oldDate = false
                if(user.commentsTime){
                    oldDate = user.commentsTime[item.id] ? user.commentsTime[item.id].date : 2
                }

                await  editUserCommentTime(id, user.id, item.id, oldDate)
            })
        }
        fetchNotData().then(() => {
            this.faviconNotific()
        })
    }

    toggleOnlyActiveHandle = () => {
        const { id } = this.props.ownProps.params
        const { settings} = this.props

        const data = {
            label: 'onlyActive',
            val: !settings.onlyActive
        }
        this.props.addSettings(id, data)

    }

    searchLineHandle = (e) => {
        const { id } = this.props.ownProps.params
        const data = {
            label: 'searchLine',
            val: e.currentTarget.value
        }
        this.props.addSettings(id, data)

    }



    render(){
        const {
            lines,
            addLine,
            linesIds,
            tags,
            tagsIds,
            openComments,
            toggleDropBox,
            fetchComments,
            //favicon,
            user,
            commentsTime,
            filterTagIds,
            editUserLineUpdateTime,
            saveRangy,
            rangy,
            settings,
            dropBox
        } = this.props;
        const { id } = this.props.ownProps.params;


        /*const handleChecked = (item, keyLine) => {
            let line = {...item}
            line.checked = !line.checked;
            line.date = Date.now()
            line.userUpdate = user.id
            this.props.editLine(id, keyLine, line)
        }*/

        const handleChecked = (item, keyLine) => {
            let line = {...item}
            line.checked = !line.checked;
            line.date = Date.now()
            line.userUpdate = user.id
            this.props.editChecked(id, keyLine, line)
        }

        const handleInputChange = (item, keyLine, text) => {
            console.log(text)

            let line = {...item}
            let tempText = getLinkFromText(text)

            line.text = tempText
            line.date = Date.now()
            line.userUpdate = user.id

            this.props.editLine(id, keyLine, line)

        }

        const saveFiles = (file, images, keyLine) => {
            if(file.type === 'image'){
                this.props.addImgToLine(id, keyLine, file)
            }

        }
        const handleDeleteLine = keyLine => {
            this.props.removeLine(id, keyLine)
        }
        const handleAddTagToLine = (indexTag, keyLine, line) => {
            const keyTag = getKeyTagByIndex(tagsIds, indexTag)
            this.props.addTagToLine(id, keyTag, keyLine)
            //this.props.editLine(id, keyLine, line)
        }
        const handleRemoveCommentsNotificIds = key => {
            removeCommentNotificToLocalStograge(key)
            this.props.removeNotificCommentIds()
        }
        const handleAddTagToFilter = keyTag => {
            this.props.addFilterTagIds(keyTag)
        }

        const getHtml = text => {
            let textNotLink = text.replace(/<\/?a[^>]*>/gim, "")
            //let textNotLink = text


            let html = linkifyHtml(textNotLink, {
                defaultProtocol: 'https',
                linkClass: 'link',
                attributes: href => {
                    return {
                        'onClick': 'window.open(this.href,\'_blank\'); return false;'
                    }
                }
            });




            return html
        }



        return (
            <div>
                <ListHeader
                    editUserLineUpdateTime = { this.editUserAllUpdateTimeHandle }
                    toggleOnlyActive = { this.toggleOnlyActiveHandle }
                    closeListHeader = { () => this.props.toggleDropBox(TOGGLE_LIST_HEADER_SUCCESS) }
                    onlyActive = { settings.onlyActive }
                    settings = { settings }
                    open = { dropBox.listHeader }
                    searchLine = { this.searchLineHandle }
                />
                <div className="lists-wrap">
                    {
                        lines.map((item, index) => {
                            if(!(settings.onlyActive && item.checked)){
                                return (
                                    <Line
                                        allTags={tags}
                                        onChecked={() => handleChecked(item, item.id)}
                                        onInput={(text, files) => handleInputChange(item, item.id, text)}
                                        onDeleteLine={() => handleDeleteLine(item.id)}
                                        addTagToLine={handleAddTagToLine }
                                        addTag={this.props.addTag }
                                        addTagToFilter={handleAddTagToFilter }
                                        openComments={ openComments }
                                        toggleDropBox={ toggleDropBox }
                                        fetchComments={ fetchComments }
                                        removeCommentsNotificIds={handleRemoveCommentsNotificIds}
                                        keyList = { id }
                                        saveFiles = {(file, images) =>  saveFiles(file, images, item.id) }
                                        { ...item }
                                        //text={  getLinkFromText(item.text)}
                                        //text={ getHtml(item.text) }
                                        index={index}
                                        key={index}
                                        user={user}
                                        commentsTime={commentsTime}
                                        filterTags={filterTagIds}
                                        editUserLineUpdateTime={editUserLineUpdateTime}
                                        rangyReducer={rangy}
                                        saveRangy={saveRangy}
                                        faviconNotific={this.faviconNotific}
                                        onlyActive={this.state.onlyActive}
                                        setDateOnLine={this.props.setDateOnLine}
                                    />

                                )
                            }


                        })
                    }
                </div>
                <div className="add-list">
                    <Button title='Add more lines' fn={() => addLine(id)} icon='icon-plus' type='big' bg='btn_white' />
                </div>

                <Favicon url={ fav } alertCount={this.state.notCount}/>
                <History/>
            </div>


        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return{
        lines: getLines(state),
        linesIds: state.linesIds,
        tagsIds: state.tagsIds,
        tags: getTags(state),
        attr: state.attr,
        title: state.title,
        //favicon: state.favicon,
        user: state.user,
        commentsTime: state.commentsTime,
        filterTagIds: state.filterTagIds,
        rangy: state.rangy,
        settings: state.settings,
        dropBox: state.dropBox,
        history: state.history,
        ownProps
    }
}

const mapDispatchToProps = {
    watchLines,
    watchTitle,
    fetchLins,
    fetchTitle,
    addLine,
    editLine,
    removeLine,
    fetchTagsColor,
    addTagToLine,
    openComments,
    toggleDropBox,
    fetchComments,
    watchComments,
    fetchTags,
    fetchNotificCommentIds,
    removeNotificCommentIds,
    //editFavicon,
    fetchUser,
    addImgToLine,
    fetchCommentsTime,
    watchCommentsTime,
    watchLineUpdateTime,
    addFilterTagIds,
    editUserLineUpdateTime,
    saveRangy,
    addTag,
    fetchSettings,
    addSettings,
    editChecked,
    setDateOnLine,
    fetchKeyList,
    watchHistory
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(Lists)


// WEBPACK FOOTER //
// ./src/containers/Lists.js